require(`lusis-ui/dist/css/app.css`)
import 'es6-promise/auto'
import Vue from 'vue'
import 'normalize.css/normalize.css' // A modern alternative to CSS resets
import ElementUI from 'element-ui'
import AsyncComputed from 'vue-async-computed'
import Storage from '@/utils/storage'

import '@/styles/index.scss' // global css
import '@/assets/themes/index.scss' // global css for multi theme

import locale from 'element-ui/lib/locale/lang/en' // lang i18n

import TangoAPI from './api'
import Acl from './utils/acl'
import App from './App'
import store from './store'
import router from './router'
import VueScreenSize from 'vue-screen-size'

import i18n from './lang' // Internationalization
import '@/icons' // icon
import '@/permission' // permission control
import '@/errorLog' // errorLog control
import * as filters from './filters' // global filters
import permissionDirective from '@/directive/permission/index.js'

Vue.use(ElementUI, {
  size: Storage.getItem('size') || 'base', // set element-ui default size
  i18n: (key, value) => i18n.t(key, value)
})

Object.keys(filters).forEach(key => { // register global utility filters.
  Vue.filter(key, filters[key])
})

Vue.use(ElementUI, { locale }) // set ElementUI lang to EN
Vue.use(TangoAPI)
Vue.use(Acl)
Vue.use(AsyncComputed)
Vue.use(permissionDirective)
Vue.use(VueScreenSize);

Vue.config.productionTip = false

new Vue({
  router,
  store,
  i18n,
  render: h => h(App),
}).$mount('#app')
